import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

// leads may be created without haushalt.einnahmen
export const toIncomeFormValues = (einnahmen: SchemaLoanRequestResolver_Get['haushalt']['einnahmen']) => ({
    ehegattenunterhalt: einnahmen?.ehegattenunterhalt ?? [],
    einkuenfteAusKapitalvermoegen: einnahmen?.einkuenfteAusKapitalvermoegen ?? [],
    einkuenfteAusNebentaetigkeit: einnahmen?.einkuenfteAusNebentaetigkeit ?? [],
    sonstigeEinnahmen: einnahmen?.sonstigeEinnahmen ?? [],
    unbefristeteZusatzrenten: einnahmen?.unbefristeteZusatzrenten ?? [],
});
